import React, { useState } from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import WhatsappTemplates from '@screens/Notifications/WhatsappTemplates';
import WhatsappTemplateList from '@screens/Notifications/WhatsappTemplateList';

/**
 * WhatsApp, en dos pasos y en este orden a propósito:
 *
 * ① **Avisos** — qué plantilla usa cada aviso del sistema. Es lo que se consulta
 *    todos los días y lo que de verdad cambia lo que recibe el cliente.
 * ② **Plantillas** — el catálogo de Twilio: crear, ver el estado de Meta y
 *    borrar. Se entra aquí cuando hace falta una nueva.
 *
 * El ciclo completo es: crear en ②, esperar a que Meta apruebe, y volver a ① a
 * vincularla. Se separan porque **una plantilla aprobada no se edita**: el texto
 * y la vinculación son cosas distintas, con tiempos distintos.
 */
const WhatsappManager: React.FunctionComponent = () => {
    const [subTab, setSubTab] = useState(0);

    return (
        <Stack height="100%">
            <Tabs
                value={subTab}
                onChange={(_, newValue) => setSubTab(newValue)}
                variant="scrollable"
                textColor="primary"
                indicatorColor="primary"
                sx={{ px: 2, minHeight: 40, flexShrink: 0, '& .MuiTab-root': { minHeight: 40, fontSize: 13 } }}
            >
                <Tab label="Avisos" />
                <Tab label="Plantillas" />
            </Tabs>
            {/* `minHeight: 0` o el hijo con height 100% empuja en vez de scrollear */}
            <Box flex={1} minHeight={0}>
                {subTab === 0 && <WhatsappTemplates />}
                {subTab === 1 && <WhatsappTemplateList />}
            </Box>
        </Stack>
    );
};

export default WhatsappManager;
